import { isNil } from 'lodash';
function addCommasWithoutDecimals(x: string | number): string {
    x = Math.round(Number(x));
    return x.toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function reduceAmount(value: number | null | undefined): string | number {
    if (isNil(value)) {
        return 0;
    }

    const shortsymbols: Record<number, string> = {
        3: 'B',
        2: 'M',
        1: 'K',
    };

    if (value === 0) {
        return value.toString();
    }

    let numberStr = value.toString()
        .split('.')[0];
    const commaCount = Math.floor((numberStr.length - 1) / 3);

    if (commaCount > 0) {
        const symbol = shortsymbols[commaCount];
        let dotPlacement = numberStr.length % 3;
        if (dotPlacement === 0) {
            dotPlacement = 3;
        }

        numberStr =
            numberStr.substring(0, dotPlacement) + '.' + numberStr.substring(dotPlacement);

        const roundedNumber = Math.floor(Number(numberStr) * 10) / 10;
        return roundedNumber + symbol;
    }

    return addCommasWithoutDecimals(numberStr);
}

export {
    reduceAmount,
};
